"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ActionTypes = require("./actionTypes");
function default_1(namespace) {
    const ActionTypes = _ActionTypes.default(namespace);
    const initialState = {
        status: 'STANDBY',
        error: undefined,
        total: 0,
        files: []
    };
    const methods = {};
    methods[ActionTypes.CLEAR] = (state, action) => {
        return initialState;
    };
    methods[ActionTypes.FETCH_REQUEST] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FETCHING', error: undefined, total: 0, files: [] });
    };
    methods[ActionTypes.FETCH_SUCCESS] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FETCHED', files: action.payload.files, total: action.payload.total });
    };
    methods[ActionTypes.FETCH_FAILURE] = (state, action) => {
        return Object.assign(Object.assign({}, state), { status: 'FAILED', error: action.payload });
    };
    const reducer = (state = initialState, action) => {
        if (methods[action.type]) {
            return methods[action.type](state, action);
        }
        return state;
    };
    return { reducer, initialState, methods, ActionTypes };
}
exports.default = default_1;
//# sourceMappingURL=reducers.js.map